import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { Physics, useSphere, usePlane, useCylinder, useBox } from "@react-three/cannon"

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { TextureLoader } from 'three/src/loaders/TextureLoader.js';
import { MeshBasicMaterial } from 'three';
import { MeshStandardMaterial } from 'three';
import { Vector3 } from 'three';

extend({ EffectComposer, RenderPass, UnrealBloomPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[aspect, 2, 0.5, 0]} />
    </effectComposer>
    </>
  )
}

function Model(props) {
  const [ref] = useSphere(() => ({ mass: 1, args: [0.4], ...props }))

  return (
    <>
      <mesh {...props} ref={ref}>
        <sphereGeometry attach="geometry" args={[0.4]} />
        <meshBasicMaterial attach="material" color={'yellow'}/>
        
        <Html>
          <div style={{color: 'white', transform: 'translate(-50%, 0)'}}>{props.text}</div>
        </Html>
      </mesh>
    </>)
}

function Plane({...props}) {
  const [ref] = usePlane(() => ({  ...props }));
  
  const texture = useLoader(TextureLoader, './road2.png');
  texture.wrapS = THREE.MirroredRepeatWrapping;
  texture.wrapT = THREE.MirroredRepeatWrapping;
  texture.repeat.set(5,5);
  // texture.rotation = 0.795;
  
  useFrame(({state, clock}) => {
    texture.offset.set(0, clock.getElapsedTime() / 3);
    // ref.current.scale.y = (Math.sin(clock.getElapsedTime()) + 1.2) * 20;
  })

  return (
    <mesh ref={ref} {...props}>
      <planeBufferGeometry args={[20, 50]} />
      <meshStandardMaterial attach="material" map={texture} side={THREE.DoubleSide} transparent={true}/>
    </mesh>
  )
}

function Cylinder(props) {
  const [ref] = useCylinder(() => ({ rotation: [Math.PI/2, 0, 0], ...props, args: [0.5,0.5, 2, 20] }))
  return (
    <mesh ref={ref}>
      <cylinderGeometry args={[0.5,0.5, 2, 20, 32]} />
      <meshStandardMaterial attach="material" color={'#444444'} side={THREE.DoubleSide}/>
    </mesh>
  )
}

function MyBox({...props}) {
  const [ref] = useBox(() => ({ ...props, args:[4,1,2] }));

  return (
    <mesh ref={ref} {...props}>
      <boxGeometry args={[4, 1]} />
      <meshStandardMaterial attach="material" color={'purple'}/>
    </mesh>
  )
}

function CameraMovement({}) {
  const {camera, scene, mouse} = useThree();
  camera.position.set(0,10, 25);
  camera.lookAt(0,5,0);

  
  useFrame(({state, clock}) => {
    camera.lookAt(mouse.x, 5 + mouse.y, 0);
  })
  return null;
}

function Character({ ...props }) {
  
  const texture2 = useLoader(TextureLoader, 'road.png');
  texture2.wrapS = THREE.MirroredRepeatWrapping;
  texture2.wrapT = THREE.MirroredRepeatWrapping;
  texture2.repeat.set(10,5);
  
  useFrame(({state, clock}) => {
    texture2.offset.set(0, clock.getElapsedTime() / 3);
  })

  return (
  <mesh {...props}>
    <sphereGeometry attach="geometry" args={[1,32,32]} />
    <meshStandardMaterial attach="material" map={texture2} transparent={true} side={THREE.BackSide}/>
  </mesh>)
}


const params = new URLSearchParams(window.location.search);
const viewer = params.get('viewer');
let viewerIsOwner = false;
let objkt = parseInt(params.get("objkt"), 10);

const query = `
query Objkt($id: bigint!) {
  hic_et_nunc_token_by_pk(id: $id) {
    token_holders(where: {quantity: {_gt: "0"}}, order_by: {id: asc}) {
      quantity
      holder {
        address
        name
      }
    }
  }
}
`;


async function fetchGraphQL(operationsDoc, operationName, variables) {
  const result = await fetch(
    "https://api.hicdex.com/v1/graphql",
    {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName
      })
    }
  );

  return await result.json();
}

async function doFetch() {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(query, "Objkt", {"id":objkt});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    const result = data.hic_et_nunc_token_by_pk;
    console.log({ result });
    return result;
  }
}

function checkViewerIsOwner(data) {
  if(!data || !data.token_holders) return;
  if (data.token_holders.some((e) => e.holder.address === viewer)) {
    console.log(`viewer IS owner`);
    viewerIsOwner = true;
  } else {
    console.log(`viewer is NOT owner`);
  }
  //console.log({ OBJKT: data });
}

function changeData(data, id) {
  let characters = [];
  console.log("Refreshing");
  if(!data || !data.token_holders) return;
  curData = curData.concat(data.token_holders.map((holder) => { return holder.holder.name ? holder.holder.name : 
    holder.holder.address.substr(0,4) + "..." + holder.holder.address.substr(-4);}));
  for (let i = curData.length - 1; i > data.length * id; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [curData[i], curData[j]] = [curData[j], curData[i]];
  }
  
  for(let i=0; i < curData.length; i++)
  {
    characters.push([(i % 8) * 2 - 7.5 + Math.random(), 18]);
  }
  
  console.log(curData)
  return characters;
}

// let data = doFetch();

let models = [], count = 0, curData=[];
for(let i=0; i < 10; i++)
{
  for(let j=0; j < 9; j++)
  {
    models[count++] = [i, j];
  }
}

function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);

  useEffect(() => {
    doFetch(objkt)
      .then((data) => changeData(data, id))
      .then((char) => set(char));
  }, [id])


  return (
    <div id="wrapper" onMouseDown={() => {setId(id+1); console.log("PRESSED")}}>
  <Canvas>
    <Effect />
      {/* <ambientLight intensity = {0.6} /> */}
      <pointLight position={[1,20,5]} intensity={20} color={'purple'}/>
      <CameraMovement />
      
      <Physics>
        {
          models.map((point) => { return <Cylinder position={[point[0] * 2 + point[1] % 2 - 9,point[1] * 3 - 10,1]} key={point[0] * 10 + point[1]}/>; })
        }
        <Plane rotation={[0, 0, 0]}/>
        <Plane rotation={[0, Math.PI / 2, 0]} position={[-12,0,10]}/>
        <Plane rotation={[0, -Math.PI / 2, 0]} position={[12,0,10]}/>
        <MyBox position={[-1,-13,1]} rotation={[0, 0, -Math.PI / 2.5]} />
        <MyBox position={[1,-13,1]} rotation={[0, 0, Math.PI / 2.5]} />
        {/* <Plane position={[0,0,2]} visible={false}/> */}
        {
          characters?.map((pos, i) => { return <Model position={[pos[0], pos[1], 1]} key={i} text={curData[i]}/>; })
        }
      </Physics>
    {/* <OrbitControls /> */}
    {/* <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
